import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, } from "@mui/material";
import { Button, Form, Image, Input, message, Select } from "antd";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import DataTable from "../../Components/DataTable";
import { capitalizeFirstLetter, getDateString } from "../../config/functions";
import appColors from "../../config/appColors";
import UserDataTable from "./UserDataTable";

const { Option } = Select;
const Users = () => {

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const user = useSelector((state) => state.authReducer.user);
  const [users, setUsers] = useState([]);

  const dispatch = useDispatch();
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => <Link
        to={{
          pathname: `/user-details/${record?._id}`,
          state: record,
        }}
      >
        {text}
      </Link>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Alternate phone',
      dataIndex: 'alternate_phone',
      key: 'alternate_phone',
    },
    {
      title: 'License no',
      dataIndex: 'license_number',
      key: 'license_number',
    },
    {
      title: 'License exp date',
      dataIndex: 'license_exp_date',
      key: 'license_exp_date',
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Created at',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (_id, record) => (
        <div>{getDateString(record.created_at)}</div>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_id, record) => (
        <div>{record.status == 1 ? "Active" : "Inactive"}</div>
      )
    },

  ];



  const getUsers = async () => {

    const onSuccess = (res) => {
      console.log('res___', res)
      dispatch(setLoader(false));
      setUsers(res?.data);
    }
    const onError = (err) => {
      console.log('user err', err)
      dispatch(setLoader(false));
    }

    const body = {
      token: user?.token
    }
    dispatch(setLoader(true));
    await postRequest(body, apiRoutes.getAllUsers, onSuccess, onError);

  }


  useEffect(() => {
    getUsers()
  }, [])


  return (
    <>
      <ThemeProvider theme={theme}>

        <div style={{ display: 'flex', }}>
          <Sidebars />
          <div style={{ marginLeft: 10, }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                Users
              </span>
            </div>
            <div>
             
              <UserDataTable
                searchColoumns={['name', 'email', 'phone', 'alternate_phone', 'license_number', 'address']}
                data={users} columns={columns} />

            </div>
          </div>
        </div>



      </ThemeProvider>
    </>
  )

}

export default Users
